import { OrganizationEffects } from './organization.effects';
import { DepartmentsEffects } from './departments.effects';
import { RolesEffects } from './roles.effects';
import { UnitsEffects } from './units.effects';
import { ModulesEffects } from './modules.effects';
import { PermissionsEffects } from './permissions.effects'
import { TemplatesEffects } from './templates.effects'


export const effects: any[] = [OrganizationEffects, DepartmentsEffects, RolesEffects, UnitsEffects, ModulesEffects, PermissionsEffects, TemplatesEffects];

export * from './organization.effects';
export * from './departments.effects';
export * from './roles.effects';
export * from './units.effects';
export * from './modules.effects';
export * from './permissions.effects';
export * from './templates.effects';
